import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments';
import { QuestTemplate } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class QuestTemplateService {
  private httpClient = inject(HttpClient);

  getAssociatedQuestTemplates(): Observable<QuestTemplate[]> {
    return this.httpClient.get<QuestTemplate[]>(
      `${environment.apiURL}/quest-templates/association`,
    );
  }
}
